module.exports = __webpack_public_path__ + "static/media/church.529a27f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/church.svg
// module id = 486
// module chunks = 0